export function scrollToSection() {

const links = document.querySelectorAll('.table-of-content-wrapper ul li a');

links.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    const section = document.querySelector(link.hash);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});

const sections = [...links]
  .map((link) => document.querySelector(link.hash))
  .filter(Boolean);

window.addEventListener("scroll", () => {
  let currentSection = "";

  sections.forEach((section, index) => {
    const sectionTop = section.offsetTop - 150;
  
    const nextSection = sections[index + 1];
    const sectionBottom = nextSection
      ? nextSection.offsetTop - 100
      : document.body.scrollHeight;
  
    if (
      window.scrollY >= sectionTop &&
      window.scrollY < sectionBottom
    ) {
      currentSection = section.id;
    }
  });

  links.forEach((link) => {
    link.classList.remove("active");

    if (link.getAttribute("href") === `#${currentSection}`) {
      link.classList.add("active");
    }
  });
});
}